import { c as _c } from "react/compiler-runtime";
import { Price } from '@7f-ui/components/price';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useExperiencePriceCategoryName } from '../_hooks/use-app-experience-price-category-name';
export interface AppPriceCategoryCountProps {
  count: number;
  category: string;
  price: number;
  currency: string;
}
export function AppPriceCategoryCount(t0) {
  const $ = _c(14);
  const {
    count,
    category,
    price,
    currency
  } = t0;
  const getExperiencePriceCategoryName = useExperiencePriceCategoryName();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = shopTestId("PriceCategoryCount.root");
    t2 = shopTestId("PriceCategoryCount.count");
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count) {
    t3 = <span data-testid={t2}>{count}</span>;
    $[2] = count;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== category || $[5] !== getExperiencePriceCategoryName) {
    t4 = getExperiencePriceCategoryName(category);
    $[4] = category;
    $[5] = getExperiencePriceCategoryName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== currency || $[8] !== price) {
    t5 = <Price amount={price} currency={currency} />;
    $[7] = currency;
    $[8] = price;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div data-testid={t1}>{t3}{" "}{t4} x {t5}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}